export default __webpack_public_path__ + "8daf584a59158ef06b092d1f1d002638.svg";